export default "__VITE_ASSET__Y68sc9fz__"